// extracted by mini-css-extract-plugin
module.exports = {"block":"block--1mrhB","button":"button--23Zqq","labels":"labels--36qif","tag":"tag--24Ubt","statesblk":"statesblk--2SB5r","row":"row--1uJfQ","long":"long--pgH_K"};
    if(module.hot) {
      // 1732531518678
      var cssReload = require("/home/kartik/kvr-lsf/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"esModule":false,"modules":{"namedExport":false},"locals":true});
      module.hot.dispose(cssReload);
      
    }
  